type ToastProps = {
  message: string | null;
  tone: "success" | "error";
};

export default function Toast({ message, tone }: ToastProps) {
  if (!message) return null;

  return (
    <div className="pointer-events-none fixed bottom-6 left-1/2 z-[110] -translate-x-1/2 px-4">
      <div
        className={`flex items-center gap-2.5 rounded-md border px-4 py-3 text-sm shadow-none ${
          tone === "success"
            ? "border-primary-200 bg-background-50 text-foreground-900"
            : "border-primary-400 bg-primary-100 text-primary-900"
        }`}
      >
        <span
          className={`flex h-5 w-5 items-center justify-center ${
            tone === "success" ? "text-primary-600" : "text-primary-700"
          }`}
        >
          <i className={tone === "success" ? "ri-checkbox-circle-line text-lg" : "ri-error-warning-line text-lg"} />
        </span>
        {message}
      </div>
    </div>
  );
}